var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MPInstanceTos } from "@/api/RequestAxios/RequestAxiosToS";
var acceptanceUrl = function (_a) {
    var tos_name = _a.tos_name, entity_id = _a.entity_id;
    return "/tos_types/".concat(tos_name, "/entity/").concat(entity_id, "/acceptance");
};
var latestTosVersionUrl = function (_a) {
    var tos_name = _a.tos_name;
    return "/tos_types/".concat(tos_name, "/versions/latest");
};
var tosDocByRevisionUrl = function (_a) {
    var tos_name = _a.tos_name, revision = _a.revision;
    return "/tos_types/".concat(tos_name, "/versions/").concat(revision, "/document");
};
var acceptTosUrl = function (_a) {
    var tos_name = _a.tos_name, revision = _a.revision;
    return "/tos_types/".concat(tos_name, "/versions/").concat(revision, "/acceptance");
};
export var getAcceptance = function (_a) {
    var entityId = _a.entityId, tosName = _a.tosName;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstanceTos.buffedInstances.get(acceptanceUrl({
                        tos_name: tosName,
                        entity_id: entityId,
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getLatestTosVersion = function (_a) {
    var tosName = _a.tosName;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstanceTos.buffedInstances.get(latestTosVersionUrl({
                        tos_name: tosName,
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getTosDocByRevision = function (_a) {
    var revision = _a.revision, tosName = _a.tosName;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstanceTos.buffedInstances.get(tosDocByRevisionUrl({ tos_name: tosName, revision: revision }), {
                        responseType: "blob",
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var acceptTos = function (_a) {
    var revision = _a.revision, entityId = _a.entityId, tosName = _a.tosName;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstanceTos.buffedInstances.post(acceptTosUrl({ tos_name: tosName, revision: revision }), {
                        entity_id: entityId,
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
//# sourceMappingURL=data:application/json;base64,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